import { render, staticRenderFns } from "./TeamsBoard.vue?vue&type=template&id=6b9fd8f4&scoped=true&"
import script from "./TeamsBoard.vue?vue&type=script&lang=js&"
export * from "./TeamsBoard.vue?vue&type=script&lang=js&"
import style0 from "./TeamsBoard.vue?vue&type=style&index=0&id=6b9fd8f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9fd8f4",
  null
  
)

export default component.exports